<template>
  <div class="row" v-if="have_corporate">
    <h4>Контакты</h4>
    <div class="col-md-12">
      <ContactList :uid=state.uid />
    </div>
    <h4>Сервисы</h4>
    <div class="col-md-12">
      <ServList :uid=state.uid />
    </div>
  </div>
  <div class="well" v-if="!have_corporate">
    <h4>Данный клиент не отмечен как корпоративный</h4>
  </div>
</template>

<script>
import darsan from "darsan"
import sysconf from "sysconf"
import ServList from "client/corpserv/ServList.vue"
import ContactList from "client/corporate/ContactList.vue"

export default {

  name: "CorpService",
  components: {ServList, ContactList},
  
  props: {
    state: Object,
  },  

  async created()
  {
    this.domain = sysconf.domainByUid(this.state.uid) || config.domain

    if (await darsan.getm(this.domain, "client", `/client/${this.state.uid}/corporate`)) {
      this.have_corporate = true
    }
  },
  
  data()
  {
    return {
      have_corporate: false,
    }
  },
 
}
</script>

<style>
  .row {
    padding-left: 10px;
  }
</style>
